import { MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined } from "@ant-design/icons";
import style from './Header.module.scss'
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { HOME_ROUTE } from "../../routing/consts";
import { GlobalContext } from "../../contexts";
import { Button, Popover, notification, Popconfirm } from "antd";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { RootState } from "../../store/store";
import { useGetNotificationsMessageQuery, useGetSelfInfoQuery } from "../../store/api/signularisApi";
import { setnew } from "../../store/slices/userinfoSlice";
import { NotificationType } from "../../types/types";

type IHeadProps = {
    toogleMenu: () => void,
    hideMenu: boolean
}

function AvatarPopover() {
    const handleExit = () => {
        localStorage.removeItem("token");
        window.location.href = '/';
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Link to={HOME_ROUTE} style={{ color: '#212d3a', fontWeight: 500, padding: '4px 0' }}>На главную</Link>
            <Popconfirm
                title="Выйти из системы?"
                onConfirm={handleExit}
                okText="Да"
                cancelText="Нет"
                placement="bottomRight"
            >
                <Button type="text" danger style={{ padding: 0, textAlign: 'left', fontWeight: 600 }}>Выход</Button>
            </Popconfirm>
        </div>
    )
}

const NotificationMessage = () => {
    const { data } = useGetNotificationsMessageQuery(null, {
        refetchOnMountOrArgChange: true,
        pollingInterval: 5000
    })

    const openNotificationWithIcon = (type: NotificationType, text: string) => {
        const typeMap: Record<NotificationType, 'success' | 'info' | 'error'> = {
            signed: 'success',
            info: 'info',
            rejected: 'error'
        };
        notification[typeMap[type]]({
            message: text,
            duration: 7,
            placement: 'topRight'
        });
    };

    useEffect(() => {
        if (data?.notifications) {
            data.notifications.forEach(({ type, text }) => {
                openNotificationWithIcon(type, text)
            })
        }
    }, [data])
    return null;
}

const Header: React.FC<IHeadProps> = ({ toogleMenu, hideMenu }) => {
    const userInfo = useAppSelector((state: RootState) => state.userinfo)
    const dispatch = useAppDispatch()
    const { data: newUsInfo } = useGetSelfInfoQuery()

    useEffect(() => {
        if (newUsInfo) dispatch(setnew(newUsInfo))
    }, [newUsInfo, dispatch])

    const { title } = useContext(GlobalContext);

    return (
        <header className={style.header}>
            {userInfo.id && <NotificationMessage />}
            
            <div className={style.left}>
                <span onClick={toogleMenu} className={style.menuIcon}>
                    {hideMenu ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </span>
                <h1 className={style.pageTitle}>{title}</h1>
            </div>

            <div className={style.right}>
                <Popover placement="bottomRight" trigger="click" content={<AvatarPopover />}>
                    <div className={style.userCard}>
                        <div className={style.userInfo}>
                            <span className={style.name}>{userInfo.firstname} {userInfo.lastname}</span>
                            <span className={style.role}>Сотрудник</span>
                        </div>
                        <div className={style.avatar}>
                            <UserOutlined />
                        </div>
                    </div>
                </Popover>
            </div>
        </header>
    );
};

export default Header;
